import { ReloadOutlined } from '@ant-design/icons'
import { Button, Spin, Typography } from 'antd'

import { QrcodeProps } from './interface'
import { useWechatQrcodeStyles } from './style'

export const Qrcode = ({
  className,
  style,
  bordered,
  size = 160,
  src,
  status,
  onRefresh
}: QrcodeProps) => {
  const { cx, styles } = useWechatQrcodeStyles({ bordered })

  const refreshBtn = onRefresh && (
    <Button icon={<ReloadOutlined />} type='link' onClick={onRefresh}>
      点击刷新
    </Button>
  )

  return (
    <div
      className={cx(styles.container, className)}
      style={{ ...style, width: size, height: size }}
    >
      {status !== 'active' && (
        <div className={styles.mask}>
          {status === 'loading' && <Spin />}
          {status === 'expired' && (
            <>
              <p>二维码过期</p>
              {refreshBtn}
            </>
          )}
          {status === 'error' && (
            <>
              <Typography.Text type='danger'>获取二维码失败</Typography.Text>
              {refreshBtn}
            </>
          )}
          {status === 'success' && (
            <>
              <Typography.Text type='success'>扫码成功</Typography.Text>
              {refreshBtn}
            </>
          )}
        </div>
      )}
      {src && <img alt='微信二维码' className={styles.qrcode} src={src} />}
    </div>
  )
}
